module.exports = __webpack_public_path__ + "img/armor.2763f612.jpg";